// src/axiosConfig.js
import axios from 'axios';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: 'https://api.dktsoft.in/grapes/index.php/api/', // Replace with your API base URL
  timeout: 10000, // Set a timeout for requests
});

// Request interceptor (before Axios request is sent)
axiosInstance.interceptors.request.use(
  (config) => {
    // Global function before request
    console.log('Before Axios Request:', config);
     showLoader();  
    alert('Y');
    // Perform other global modifications if needed
    return config;
  },
  (error) => {
    // Handle request error globally
     hideLoader();
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);
const showLoader = () => {
  const loaderDiv = document.createElement('div');
  loaderDiv.id = 'loader';
  loaderDiv.className =
    'w-screen h-screen flex-center bg-white dark:bg-dark-card fixed inset-0 z-[9999]';
  loaderDiv.innerHTML = `
    <img src="assets/images/loader.gif" alt="loader">
  `;
  document.body.appendChild(loaderDiv);
};

// Function to remove the loader from the DOM
const hideLoader = () => {
  const loaderDiv = document.getElementById('loader');
  if (loaderDiv) {
    document.body.removeChild(loaderDiv);
  }
};
// Response interceptor (after Axios request completes)
axiosInstance.interceptors.response.use(
  (response) => {
    // Global function after response is received
    console.log('After Axios Response:', response);
 hideLoader();
    // Perform global actions with response data if needed
    return response;
  },
  (error) => {
    // Handle response error globally
    console.error('Response Error:', error);
 hideLoader();
    // Optionally, you can check error status and handle it
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized access. Redirecting to login...');
      // Redirect to login or perform other actions
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
